module.exports = __webpack_public_path__ + "static/media/d_big-score.943389d0.png";